import { useQuery } from '@tanstack/react-query';
import { CatalystInsightFilterRequest } from '@toggle/toggle';

import {
  getCatalystInsightDetails,
  getCatalystInsightList,
} from '~/services/insights/catalyst-insights-service';
import { useFlags } from '~/stores/use-flags/useFlags';

export const QUERY_KEY_CATALYST_INSIGHT = 'QUERY_KEY_CATALYST_INSIGHT';

export const useCatalystInsightsList = (
  payload: CatalystInsightFilterRequest,
  isEnabled = true
) => {
  const {
    isCatalystCompanyInsightsEnabled,
    isCatalystThemeInsightsEnabled,
    isCatalystGeoInsightsEnabled,
    isCatalystMacroInsightsEnabled,
  } = useFlags(state => ({
    isCatalystCompanyInsightsEnabled: state.getFeatureFlagState(
      'catalysts_company_insights'
    ),
    isCatalystThemeInsightsEnabled: state.getFeatureFlagState(
      'catalysts_theme_insights'
    ),
    isCatalystGeoInsightsEnabled: state.getFeatureFlagState(
      'catalysts_geo_insights'
    ),
    isCatalystMacroInsightsEnabled: state.getFeatureFlagState(
      'catalysts_macro_insights'
    ),
  }));

  return useQuery({
    queryKey: [QUERY_KEY_CATALYST_INSIGHT, payload],
    queryFn: () => getCatalystInsightList(payload),
    select: data =>
      data.filter(
        insight =>
          (isCatalystCompanyInsightsEnabled ||
            insight.category !== 'company') &&
          (isCatalystThemeInsightsEnabled ||
            insight.sub_category !== 'thematic') &&
          (isCatalystGeoInsightsEnabled || insight.sub_category !== 'geopolitical_global_events') &&
          (isCatalystMacroInsightsEnabled || insight.sub_category !== 'macroeconomic_policy_changes')
      ),
    staleTime: 0,
    gcTime: 0,
    enabled: isEnabled,
  });
};

export const QUERY_KEY_CATALYST_INSIGHT_DETAILS =
  'QUERY_KEY_CATALYST_INSIGHT_DETAILS';

export const useCatalystInsightDetails = (
  insightId: string,
  isEnabled = true
) => {
  return useQuery({
    queryKey: [QUERY_KEY_CATALYST_INSIGHT_DETAILS, insightId],
    queryFn: () => getCatalystInsightDetails(insightId),
    staleTime: 0,
    gcTime: 0,
    enabled: isEnabled,
  });
};
